import { render, staticRenderFns } from "./ultimos-pedidos.vue?vue&type=template&id=6f88bc05&scoped=true"
import script from "./ultimos-pedidos.vue?vue&type=script&lang=js"
export * from "./ultimos-pedidos.vue?vue&type=script&lang=js"
import style0 from "./ultimos-pedidos.vue?vue&type=style&index=0&id=6f88bc05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f88bc05",
  null
  
)

export default component.exports